// checks if we can show the census note icon
// valid for people with the visit notes flag
// AND if the chart is signed_on (ORU)
import FEATURES from './featuresConstants'

export function shouldShowNoteIcon(features, visitCharge) {
  return features?.includes(FEATURES.VisitNotesPOC) || visitCharge?.chart?.signed_on
}

export function isTestFeature() {
  return (
    window.location.host.includes('stage') ||
    window.location.host.includes('test') ||
    window.location.host.includes('dev') ||
    window.location.host.includes('localhost')
  )
}

// rules for if we can show LTC
export function showLongTermCare(features, pos) {
  return features?.includes(FEATURES.POS32) && (pos === '31' || pos === '32')
}

export function getIsAi() {
  return window.location.href.includes('-ai') || window.location.href.includes('localhost')
}
